<template>
  <div class="icons" :style="{ fontSize: fontSize }">
    <SmsIcon v-if="type === 'Dms'"></SmsIcon>
    <SmsIcon v-if="type === 'SMS'"></SmsIcon>
    <SmsIcon v-if="type === 'Sms'"></SmsIcon>
    <SmsIcon v-if="type === 'Cellfind'"></SmsIcon>
    <SmsIcon v-if="type === 'Mtech'"></SmsIcon>
    <SmsIcon v-if="type === 'Default'"></SmsIcon>
    <SmsIcon v-if="type === 'Infobip'"></SmsIcon>
    <SmsIcon v-if="type === 'Bumblebee'"></SmsIcon>
    <EmailIcon v-if="type === 'Email'"></EmailIcon>
    <UssdIcon v-if="type === 'USSD'"></UssdIcon>
    <WechatIcon v-if="type === 'WeChat'"></WechatIcon>
    <MobileIcon v-if="type === 'Mobile'"></MobileIcon>
    <TwitterIcon v-if="type === 'Twitter'"></TwitterIcon>
    <WebhookIcon v-if="type === 'Web Hook'"></WebhookIcon>
    <ImportIcon v-if="type === 'Import'"></ImportIcon>
    <CellfindIcon v-if="type === 'CellFind'"></CellfindIcon>
    <FacebookIcon v-if="type === 'Facebook'" :official="fbOfficial"></FacebookIcon>
    <TelegramIcon v-if="type === 'Telegram'"></TelegramIcon>
    <WhatsappIcon v-if="type === 'WhatsApp'"></WhatsappIcon>
    <WhatsappIcon v-if="type === 'Whatsapp'"></WhatsappIcon>
    <WhatsappWebIcon v-if="type === 'WhatsAppWeb'"></WhatsappWebIcon>
    <InstagramIcon v-if="type === 'Instagram'"></InstagramIcon>
    <SurveyIcon v-if="type === 'Survey'"></SurveyIcon>
    <TiktokIcon v-if="type === 'TikTok'"></TiktokIcon>
    <ChannelAppIcon v-if="type === 'Waboxapp'"></ChannelAppIcon>
    <ChannelAppIcon v-if="type === 'Trumpia'"></ChannelAppIcon>
  </div>
</template>

<script>
import SmsIcon from './SmsIcon';
import UssdIcon from './UssdIcon';
import EmailIcon from './EmailIcon';
import WechatIcon from './WechatIcon';
import MobileIcon from './MobileIcon';
import WebhookIcon from './WebhookIcon';
import TwitterIcon from './TwitterIcon';
import FacebookIcon from './FacebookIcon';
import TelegramIcon from './TelegramIcon';
import WhatsappIcon from './WhatsappIcon';
import WhatsappWebIcon from './WhatsappWebIcon';
import CellfindIcon from './CellfindIcon';
import InstagramIcon from './InstagramIcon';
import SurveyIcon from './SurveyIcon';
import ChannelAppIcon from './ChannelAppIcon';
import ImportIcon from './ImportIcon';
import TiktokIcon from './TiktokIcon';

export default {
  name: 'SocialIcon',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    fbOfficial: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    fontSize: {
      type: String,
      default: 'inherit',
    },
  },
  components: {
    SmsIcon,
    EmailIcon,
    UssdIcon,
    WechatIcon,
    MobileIcon,
    WebhookIcon,
    TwitterIcon,
    CellfindIcon,
    FacebookIcon,
    TelegramIcon,
    InstagramIcon,
    WhatsappIcon,
    WhatsappWebIcon,
    SurveyIcon,
    ChannelAppIcon,
    ImportIcon,
    TiktokIcon,
  },
};
</script>



// WEBPACK FOOTER //
// SocialIcon.vue?fd49d374